import React, { useState } from "react"
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Toolbar2 = (props) => {
    const { className } = props
    const classes = useStyles();
    const [age, setAge] = useState()

    return (
        <div className={className}>
            <div className="parentdiv">
                <div className="firstbut">
                    <h3>Առկայություն</h3>
                    <div className="ButParent">
                        <Button size="small" variant="contained" style={{ "background-color": "#9da79d" }}>Հոսքագծերում</Button>
                        <Button size="small" variant="contained" style={{ "background-color": "#9da79d" }}> Որակի նախ․հսկում </Button>
                        <Button size="small" variant="contained" style={{ "background-color": "#9da79d" }}>Որակի հսկում</Button>
                        <Button size="small" variant="contained" style={{ "background-color": "#9da79d" }}>Պահեստ </Button>
                    </div>
                </div>
                <div className="selecttab">
                    <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-helper-label">Պար</InputLabel>
                        <Select
                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            value={age}
                        // onChange={handleChange}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            <MenuItem value={10}>Տարբերակ 1</MenuItem>
                            <MenuItem value={20}>Տարբերակ 2</MenuItem>
                            <MenuItem value={30}>․․․</MenuItem>
                        </Select>

                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-helper-label">Արժեք</InputLabel>
                        <Select
                            value={age}
                            // onChange={handleChange}
                            displayEmpty
                            className={classes.selectEmpty}
                            inputProps={{ 'aria-label': 'Without label' }}
                        >

                            <MenuItem value={10}>Տարբերակ 1</MenuItem>
                            <MenuItem value={20}>Տարբերակ 2</MenuItem>
                            <MenuItem value={10}>Տարբերակ 3</MenuItem>
                            <MenuItem value={20}>Տարբերակ 4</MenuItem>
                        </Select>
                        {/* <FormHelperText>Without label</FormHelperText> */}
                    </FormControl>
                </div>
                <div className="secondbut">
                    <h3>Ստատուս</h3>
                    <div className="ButParent">
                        <Button size="small" variant="contained" color="primary">OK</Button>
                        <Button size="small" variant="contained" color="primary"> Վերաուղղված </Button>
                        <Button size="small" variant="contained" color="primary">Չստուգված</Button>
                    </div>
                </div>
                <div className="thirdbut">
                    <h3>Ստատուսի ժամկետ</h3>
                    <div className="ButParent">
                        <Button size="small" variant="contained" style={{ "background-color": "#56b544" }}>Մինչև 2օր</Button>
                        <Button size="small" variant="contained" style={{ "background-color": "#cde83a" }}>2-5 օր</Button>
                        <Button size="small" variant="contained" style={{ "background-color": "#de3a3a" }}>5 օրից ավել</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Toolbar2